/* global axios */

import ApiClient from 'dashboard/api/ApiClient';

class OperationalCatalog extends ApiClient {
  constructor() {
    super('custom/operational_catalog', { accountScoped: true });
  }

  resolve({ conversationId, kinds = [], inboxIds = [], teamIds = [] } = {}) {
    return axios.get(this.url, {
      params: {
        conversation_id: conversationId,
        kinds,
        inbox_ids: inboxIds,
        team_ids: teamIds,
      },
    });
  }

  getScope({ resourceKind, resourceId }) {
    return axios.get(this.url, {
      params: {
        resource_kind: resourceKind,
        resource_id: resourceId,
      },
    });
  }
}

export default new OperationalCatalog();
